import ErrorHandler from '../error-handlers/axios/defaultErrorHandler';

/**
 * Fetches lead enquiries for a specific lead
 * @param {Axios} axiosInstance - The axios instance to use
 * @param {string} leadId - The ID of the lead to fetch enquiries for
 * @param {Object} options - Optional parameters for the request
 * @param {number} options.page - Page number for pagination (default: 1)
 * @param {number} options.limit - Number of records per page (default: 10)
 * @returns {Promise<Object>} - The response data
 */
export const getLeadEnquiries = async (axiosInstance, leadId, options = {}) => {
  try {
    const page = options?.page || 1;
    const limit = options?.limit || 10;

    const res = await axiosInstance.get(`/lead-enquiries/lead/${leadId}`, {
      params: {
        page,
        limit,
        ...options
      }
    });

    return res?.data;
  } catch (error) {
    ErrorHandler.handle(error);
    return { found: 0, data: [] };
  }
};
